export const ONNET_OFFNET_LIST_REQUEST = 'ONNET_OFFNET_LIST_REQUEST';
export const ONNET_OFFNET_LIST_SUCCESS = 'ONNET_OFFNET_LIST_SUCCESS';
export const ONNET_OFFNET_LIST_FAILURE = 'ONNET_OFFNET_LIST_FAILURE';

interface OnnetOffnetAction {
  type: string
  payload: any
}

export interface OnnetOffnetResult {
  ranges: Array<OnnetOffnetRow>
  rangesIpv6: Array<OnnetOffnetRow>
  opco: string
}

export interface OnnetOffnetRow {
  entry: string
  entryStatus: string
  editable?: boolean
  newEntry?: boolean
}

export enum IPGroup {
  v4 = 'v4',
  v6 = 'v6',
}

const initialState: OnnetOffnetResult = {
  ranges: [],
  rangesIpv6: [],
  opco: ''
}

function mapRangePayload(range: string) {
  return {
    entry: range,
    editable: false
  }
}

export default function (state = initialState, action: OnnetOffnetAction) {
  switch (action.type) {
    case ONNET_OFFNET_LIST_SUCCESS:
      const data = action.payload
      const stateClone = { ...state }

      stateClone.opco = data.opco
      stateClone.ranges = data.ranges.map(mapRangePayload)
      stateClone.rangesIpv6 = data.rangesIpv6.map(mapRangePayload)
      return { ...stateClone }

    default:
      return { ...state }
  }
}
